import { render } from "./VaIconMessage.vue?vue&type=template&id=7a11e949"
import script from "./VaIconMessage.vue?vue&type=script&lang=js"
export * from "./VaIconMessage.vue?vue&type=script&lang=js"

import "./VaIconMessage.vue?vue&type=style&index=0&id=7a11e949&lang=scss"
script.render = render

export default script